
export default function constructToursCardsPerformance(data) {
    am4core.ready(() => {

        // Themes begin
        am4core.useTheme(am4themes_animated);
        // Themes end

        var chart = null;

        const maxVal = Math.max.apply(null, data.views.map(i => i))

        if (!chart) {
            chart = am4core.create('cards-funnel', am4charts.SlicedChart);
            chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect
            chart.logo.disabled = true;

            chart.events.on("datavalidated", function (ev) {

                let targetHeight = 550;

                if (data.views.length < 9) targetHeight = 520;
                if (data.views.length < 8) targetHeight = 400;
                if (data.views.length < 4) targetHeight = 300;

                chart.svgContainer.htmlElement.style.height = targetHeight + "px";
            });

            var series = chart.series.push(new am4charts.FunnelSeries());
            series.dataFields.value = "value";
            series.dataFields.category = "name";
            series.alignLabels = true;
            series.orientation = "horizontal";
            series.fontSize = '12px';
            series.bottomRatio = 1;
            series.labels.template.text = "{category}: [bold]{percentage}[/]";
            series.slices.template.tooltipText = "{category}: [bold]{percentage}[/]";

            series.colors.step = 1;
            series.colors.stepOptions = {
                lightness: 0.03,
                hue: 0
            };
            series.colors.wrap = false;
            series.colors.list = [
                //am4core.color('#80DDFD')
                am4core.color('#006AA9')
            ];
        }

        let finalData = [];
        for (let i = 0; i < data.xAxisCategories.length; i++) {
            finalData[i] = {
                name: data.xAxisCategories[i],
                value: data.views[i],
                percentage: ((data.views[i] / maxVal) * 100).toFixed(2) + ' %'
            }
        }

        chart.data = finalData;
    });
}